import { RouteConfig } from 'vue-router'

/**
 * 积分活动路由 name 约定（与 apph5 motivationPoint 入口分发一致）：
 * 当期 id 固定格式为 {season}_{year}，如 spring_2026、autumn_2025。
 * name：activity_{season}_points_{year}
 */
export const IndexRoute: RouteConfig = {
  path: '/activity/summer-points-2026',
  name: 'activity_summer_points_2026',
  component: () => import('./2026-summer/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026暑假体育作业学生积分活动',
  },
}

export const Autumn2026Route: RouteConfig = {
  path: '/activity/autumn-points-2026',
  name: 'activity_autumn_points_2026',
  component: () => import('./2026-autumn/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026秋季体育积分',
  },
}

export const AuctionWinnersRoute: RouteConfig = {
  path: '/activity/motivation-point/auction-winners',
  name: 'activity_motivation_point_auction_winners',
  component: () => import('./auction-winners/AuctionWinners.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '竞拍获奖名单',
  },
}

export default [IndexRoute, Autumn2026Route, AuctionWinnersRoute]
